import { useNavigate } from 'react-router-dom'
import { getAuth } from 'firebase/auth'
import { Layout } from '../components/layout'
import { useEffect, useCallback } from 'react'

export default function Logout() {
  const navigate = useNavigate()

  const handleLogout = useCallback(async () => {
    const auth = getAuth()
    await auth.signOut()
    await new Promise((r) => setTimeout(r, 500))
    return navigate('/login')
  }, [navigate])

  useEffect(() => {
    void handleLogout()
  }, [handleLogout])

  return <Layout title="Logging you out..."></Layout>
}
